<template>
  <create-product-layout :short-create-form="true"
                         title="ساخت محصول"
                         :submitFunction="createProduct"/>
</template>


<script>
import {mapActions} from 'vuex';
import CreateProductLayout from "../../../components/dashboard/product/CreateLayout";


export default {
  name: "CreateStoreProduct",
  components: {CreateProductLayout},
  methods: {
    ...mapActions({
      createProduct: "Product/createProduct"
    })
  }
};
</script>

<style scoped>

</style>